import axios from 'axios';
import { baseURL, api_key } from './config';
import { message } from 'antd';

// 创建 axios 实例,设置基础配置
const instance = axios.create({
 baseURL, // 基础URL,所有请求都会加在这个URL前面
 timeout: 50000, // 请求超时时间,单位毫秒
});

// 设置默认请求头,添加API密钥
instance.defaults.headers.common['X-Api-Key'] = api_key;

/**
* 封装请求方法
* @param {Object} config - axios请求配置对象
* @returns {Promise} 返回处理后的响应数据
*/
const makeRequest = async config => {
 try {
   // 发送请求
   const response = await instance.request(config);

   // 判断请求状态,非200显示错误信息
   if (response.data.status !== 200) {
     message.error(response.data.error);
   } else {
     return response.data;
   }
 } catch (error) {
   // 请求失败,抛出错误
   throw new Error(error.response.data);
 }
};

/**
* 统一的请求方法
* @param {string} method - 请求方法 (get, post, put, delete等)
* @param {string} url - 请求地址
* @param {Object} data - 请求体数据 (一般用于POST请求)
* @param {Object} params - URL参数 (一般用于GET请求)
* @param {Object} headers - 自定义请求头
* @returns {Promise} 返回处理后的响应数据
*/
const sendRequest = async (
 method,
 url,
 data = null, // 默认为null
 params = null, // 默认为null
 headers // 可选的请求头
) => {
 // 组装请求配置
 const config = {
   method,
   url,
   data,
   params,
   headers,
 };

 return makeRequest(config);
};

export { sendRequest };
